import {t} from '../../../common/getTranslations';
import {formatWithCommas} from '../../../common/shared/utils/formatWithCommas';
import {twMerge} from '../../../common/twMerge';
import {TicketKind} from '../../../graphql/generated/types';
import {Separator} from '../../atoms/Separator/Separator';
import {Text} from '../../atoms/Text/Text';
import {BuyTicketPurchasableItemProps} from './BuyTicketPurchasableItemProps.interface';

export function BuyTicketPurchasableItem({
  ticketKind,
  ticketTitle,
  totalQuantity,
  discount,
  price,
  onClickPurchase,
  className,
  ...props
}: BuyTicketPurchasableItemProps) {
  return (
    <div
      className={twMerge(
        'flex items-center justify-between py-14pxr',
        className
      )}
      {...props}
    >
      <div className="flex flex-col">
        <Text className="font-small1-bold text-theme-solid-100">
          {ticketTitle}
        </Text>
        <Text className="font-small2 mt-2pxr flex items-center text-theme-solid-60">
          {totalQuantity && (
            <>
              <Text>
                {t('ticket_purchase_purchase_all_count', {
                  values: {
                    value: formatWithCommas(totalQuantity),
                  },
                })}
              </Text>
              {!!discount && discount > 0 && (
                <Separator className="mx-6pxr h-12pxr bg-theme-transparent-20" />
              )}
            </>
          )}
          {!!discount && discount > 0 && (
            <>
              {t(
                ticketKind === TicketKind.Rent
                  ? 'ticket_purchase_cash_discount_rental'
                  : 'ticket_purchase_cash_discount_possession',
                {
                  values: {
                    value: formatWithCommas(discount),
                  },
                }
              )}
            </>
          )}
        </Text>
      </div>
      <button
        className={twMerge(
          'font-small1-bold w-104pxr rounded-2pxr bg-static-point-green py-10pxr text-static-mono-10',
          ticketKind === TicketKind.Own && 'bg-static-point-blue'
        )}
        onClick={onClickPurchase}
      >
        {t('common_cash_amount', {
          values: {
            value: formatWithCommas(price),
          },
        })}
      </button>
    </div>
  );
}
